import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule } from '../../material/material.module';
import {
  Chat,
  ChatControllerService,
  UserRef,
} from '../../../core/generated';
import { FormsModule } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UserPreferencesCacheService } from '../../services/user-preferences-cache.service';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-dialog-chat',
    standalone: true,
    imports: [MaterialModule, FormsModule],
    templateUrl: './dialog-chat.component.html',
    styleUrl: './dialog-chat.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogChatComponent implements OnInit, AfterViewInit {
  isMobile = this.deviceService.isMobile();
  data = inject(MAT_DIALOG_DATA);
  messageInput: string = '';
  chats: Chat[] = [];
  user!: UserRef;
  displaySize = 5;
  eventSource: EventSource | undefined;
  @ViewChild('chatDiv') chatDiv: ElementRef | undefined;

  constructor(
    private chatService: ChatControllerService,
    private cd: ChangeDetectorRef,
    private deviceService: DeviceDetectorService,
    private UserPreferencesCacheService: UserPreferencesCacheService
  ) { }

  async ngOnInit() {
    await this.getChats();
    await this.loadUserProfile();
  }

  ngAfterViewInit(): void {
    this.eventSource = new EventSource(
      environment.apiUrl +
      'chat/stream?customerServiceId=' +
      this.data.customerService.id
    ); // Substitua pela URL do seu servidor SSE
    this.eventSource.onmessage = (event) => {
      const chat: Chat = JSON.parse(event.data);
      this.chats = [chat, ...this.chats]; // Adiciona a nova notificação à lista
      this.cd.detectChanges();
      this.chats.push(chat);
      this.cd.detectChanges();
    };

    this.eventSource.onerror = (error) => {
      console.error('Erro no SSE:', error);
    };
  }

  ngOnDestroy() {
    if (this.eventSource) {
      this.eventSource.close(); // Fecha a conexão SSE quando o componente é destruído
    }
  }

  getChats() {
    this.chatService
      .findByCustomerServiceId(this.data.customerService.id)
      .subscribe((chats) => {
        this.chats = chats;
        this.cd.detectChanges();
        this.scrollToBottom();
      });
  }

  async sentMessage() {
    let newChat: Chat = { message: this.messageInput };

    if (this.messageInput.length > 0) {
      let chat: Chat = await firstValueFrom(
        this.chatService.save15(this.data.customerService.id, newChat)
      );

      if (chat) {
        await this.getChats();
      }

      this.messageInput = '';
    }
  }

  async loadUserProfile() {
    await this.UserPreferencesCacheService.getUser().subscribe((user) => {
      this.user = user;
    });
  }

  isUserSender(id: number) {
    return this.user?.id === id;
  }

  displayLimit(index: number) {
    return index > this.chats.length - this.displaySize;
  }

  scrollToTop() {
    this.displaySize = this.displaySize + 3;

    if (this.chatDiv) {
      this.chatDiv.nativeElement.scrollTop = 0;
    }
  }

  scrollToBottom() {
    if (this.chatDiv) {
      this.chatDiv.nativeElement.scrollTop =
        this.chatDiv.nativeElement.scrollHeight;
    }
  }
}